import { environment } from '../../../environments/environment';
import { buildBaseUrl } from '@core/utils/url.utils';
import { defaultConfig } from '../../app.config';

/**
 * Carga config PÚBLICA desde el gateway (GET /api/public-config) al arrancar y la aplica sobre
 * `environment`. Cubre:
 *   - `siteKey` de reCAPTCHA (única fuente de verdad, casa con el secretKey del gateway).
 *   - `publicApiSignature` (clientAppCode + signatureKey dedicada del frontend) para el interceptor
 *     de firma pública, tomada en runtime en vez de hornearse. Se pasa `?app=<clientAppCode>` para
 *     que el gateway devuelva la key de ESTE frontend (poblada desde appOperation).
 * Rotar cualquiera de las dos = cambio de datos en el gateway/appOperation, sin recompilar.
 *
 * Fail-safe: ante cualquier fallo/timeout se conserva el valor horneado en `environment`, para que
 * la app siempre arranque. Se usa fetch (no HttpClient) para no depender de interceptores en el boot.
 */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const base = buildBaseUrl(defaultConfig?.serverEntryPoint);
    const appCode = defaultConfig?.clientAppCode ?? '';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    const res = await fetch(`${base}/api/public-config?app=${encodeURIComponent(appCode)}`, {
      signal: controller.signal,
    });
    clearTimeout(timer);
    if (!res.ok) {
      return;
    }
    const cfg = await res.json();
    if (cfg?.recaptcha?.siteKey) {
      environment.recaptcha = { ...environment.recaptcha, siteKey: cfg.recaptcha.siteKey };
    }
    if (cfg?.publicApiSignature?.clientAppCode && cfg?.publicApiSignature?.signatureKey) {
      environment.publicApiSignature = {
        clientAppCode: cfg.publicApiSignature.clientAppCode,
        signatureKey: cfg.publicApiSignature.signatureKey,
      };
    }
  } catch {
    // Fail-safe: se conserva environment (valores del bundle).
  }
}
